import React from "react";
import Swiper from "../Swiper/Swiper";
import "./Schedule.less";
import ScheduleCard from "./ScheduleCard/ScheduleCard";
import { PnpService } from "../../../services/pnp-service";
import { ApiService } from "../../../services/api-service";

function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

class Schedule extends React.Component {
  constructor(props) {
    super(props);

    this.pnpService = new PnpService();
    this.apiService = new ApiService();

    this.state = {
      availableDates: [],
      scheduleMap: {},
      selectedDate: null,
      selectedHours: ['8 am - 12 pm', '1 pm - 5 pm', '6 pm - 8 pm'],
      selectedHour: null,
      showHours: false,
    };
  }

  componentDidMount() {
    const today = new Date().toISOString();
    const todayFormatted = today.split("T")[0] + "T00:00:00Z";
    this.pnpService.getListByTitle(
      "horariosContactoMP",
      (list) => {
        const scheduleMap = {};
        const availableDates = [];

        list.forEach((item) => {
          const dateObj = new Date(item.CSCalendarioDateTime);

          const formattedDate = dateObj.toLocaleDateString("es-ES", {
            weekday: "long",
            day: "2-digit",
            month: "long",
          });

          const day = dateObj.toLocaleDateString("es-ES", { day: "2-digit" });
          const month = dateObj.toLocaleDateString("es-ES", { month: "long" });
          const weekday = dateObj.toLocaleDateString("es-ES", {
            weekday: "long",
          });

          const id = item.ID;
          scheduleMap[id] = {
            id,
            formattedDate,
            day,
            month,
            weekday,
            CSCalendarioDateTime: item.CSCalendarioDateTime,
            hours: item.CSHorarioMultiChoice.results,
          };

          availableDates.push(scheduleMap[id]);
        });

        this.setState({
          availableDates,
          scheduleMap,
        });
      },
      "/salud",
      `CSCalendarioDateTime ge datetime'${todayFormatted}'`
    );
  }

  handleSelectDate = (date) => {
    try {
      console.log('date: ', date);
      this.setState({
        selectedDate: date,
        selectedHours: Array.isArray(date.hours) ? date.hours : [],
        selectedHour: null,
      });
      console.log('selectedHours: ', this.state.selectedHours);
      this.props.onSelectedDateChange(date);
    } catch (error) {
      console.log('error handleSelectDate: ', error);
    }
  };

  handleSelectHour = (hour) => {
    this.setState({
      selectedHour: hour,
    });
    this.props.onSelectedHourChange(hour);
  };

  validateTimeSlot = (hour) => {
    const { selectedDate } = this.state;
    if (!selectedDate) return true;

    // Convertir la fecha seleccionada a un objeto Date
    const selectedDateTime = new Date(selectedDate.CSCalendarioDateTime);
    const today = new Date();

    // Verificar si la fecha seleccionada es hoy
    const isToday = selectedDateTime.toDateString() === today.toDateString();

    if (!isToday) return false; // Si no es hoy, no deshabilitar nada

    // Obtener la hora actual en formato de 24 horas
    const currentHour = today.getHours();

    // Extraer la hora de inicio del rango de horas
    const hourParts = hour.split(" - ")[0]; // Ej: "8 am" de "8 am - 12 pm"
    let [hourValue, period] = hourParts.split(" ");
    hourValue = parseInt(hourValue, 10);

    // Convertir la hora a formato 24h
    if (period === "pm" && hourValue !== 12) hourValue += 12;
    if (period === "am" && hourValue === 12) hourValue = 0;

    // Si la hora actual es mayor o igual a la hora de inicio, deshabilitar
    return currentHour >= hourValue;
  };


  createRequestBody(
    contributor,
    beneficiaries,
    idCotization,
    totalCostCotization,
    selectedDate,
    selectedHour
  ) {
    const formatDateToTimestamp = (dateString) => {
      const date = new Date(dateString);
      return `/Date(${date.getTime()})/`;
    };

    const mapBeneficiaries = beneficiaries.map((beneficiary) => ({
      Nombre: beneficiary.name,
      Categoria: beneficiary.category,
      EPSCompensar: beneficiary.compensationUser ? "8" : "111",
      TipoDeDocumento: beneficiary.documentType,
      NumeroDeDocumento: beneficiary.documentNumber,
      Edad: beneficiary.age,
      Genero: beneficiary.gender,
      Parentesco: beneficiary.relation,
      CajaCompensacion: beneficiary.compensationUser,
      PlanComplementario: beneficiary.complementaryPlan,
      FechaNacimiento: beneficiary.birthDate,
    }));

    const requestBody = {
      Beneficiario: mapBeneficiaries,
      Datos: {
        TarifaMes: totalCostCotization,
        ValorContrato: totalCostCotization * 12, // Suponiendo un contrato anual
        ContactoTelefonoMovil: contributor.phone,
        ContactoCorreo: contributor.email,
        TipoConsulta: "Simulaciones autorizadas",
        Categoria: contributor.category,
        EPSCompensar: contributor.compensationUser ? "8" : "111",
        AceptoInfoMensMovil: contributor.receiveSms ? "Si" : "No",
        AutorizoDatosPersonales: contributor.termsAccepted ? "Si" : "No",
        CSAceptoInfoEmailText: contributor.receiveEmail ? "Si" : "No",
        ContactoFecha: formatDateToTimestamp(selectedDate.CSCalendarioDateTime),
        ContactoHorario: selectedHour,
        Genero: contributor.gender,
        Parentesco: "Titular",
      },
      IdCotizacion: idCotization.toString(),
      Interesado: {
        NumeroDeDocumento: contributor.documentNumber,
        TipoDeDocumento: contributor.documentType,
        Nombre: contributor.name,
        CorreoElectronico: contributor.email,
        NIT: "",
        TipoDocEmpresa: "",
        FechaNacimiento: contributor.birthDate,
        CajaCompensacion: contributor.compensationUser ? "Compensar" : "",
        Categoria: contributor.category,
        EPSCompensar: contributor.compensationUser,
        Edad: contributor.age,
      },
    };

    return requestBody;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { contributor, beneficiaries, idCotization, totalCostCotization } =
      this.props;
    const { selectedDate, selectedHour } = this.state;

    const requestBody = this.createRequestBody(
      contributor,
      beneficiaries,
      idCotization,
      totalCostCotization,
      selectedDate,
      selectedHour
    );

    this.apiService
      .post("ServicioConsorcio.svc/GuardarSimulacionCotizadorMP", requestBody)
      .then((response) => {
        console.log("response", response);
        this.props.onNextStep(4);
      })
      .catch((error) => {
        console.error("Error al obtener el costo estimado:", error);
      });
  };

  render() {
    const { contributor } = this.props;
    const { selectedDate, selectedHours, selectedHour } = this.state;

    return (
      <div className="schedule-container">
        <h2 className="title">Agendar contacto con asesor</h2>
        <p className="description">Verifica que tus datos estén correctos.</p>
        <hr className="divider-dashed" />

        <div className="contributor-info">
          <table>
            <tbody>
              <tr>
                <td className="valueTitle">Nombre:</td>
                <td className="value">{contributor?.name}</td>
                <td className="valueTitle">Teléfono:</td>
                <td className="value">{contributor?.phone}</td>
              </tr>
              <tr>
                <td className="valueTitle">Documento:</td>
                <td className="value">{contributor?.documentNumber}</td>
                <td className="valueTitle">Correo:</td>
                <td className="value">{contributor?.email}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <hr className="divider-dashed" />

        <h2 className="title">
          Selecciona una fecha y hora para ser contactado
        </h2>

        <br />

        <div className="schedule-swiper-container">
          <Swiper slidesPerView={5}>
            {this.state.availableDates.map((date, index) => (
              <ScheduleCard
                key={index}
                date={date.day}
                month={capitalizeFirstLetter(date.month)}
                day={capitalizeFirstLetter(date.weekday)}
                onClick={() => this.handleSelectDate(date)}
                active={this.state.selectedDate?.id === date.id}
              />
            ))}
          </Swiper>

          <div className="hours-container">
            {selectedHours.map((hour, index) => {
              const isDisabled = this.validateTimeSlot(hour);

              return (
                <span
                  key={index}
                  className={`hour-button ${selectedHour === hour ? "active" : ""} ${isDisabled ? "disabled" : ""}`}
                  onClick={!isDisabled ? () => this.handleSelectHour(hour) : null}
                >
                  {hour}
                </span>
              );
            })}
          </div>


        </div>
        {selectedHours.lenght > 0 && (
          <div className="hours-container">
            {selectedHours.map((hour, index) => (
              <span
                key={index}
                className={`hour-button ${selectedHour === hour ? "active" : ""}`}
                onClick={() => this.handleSelectHour(hour)}
              >
                {hour}
              </span>
            ))}
          </div>
        )}
        <br />
        <button className="continue-btn" onClick={this.handleSubmit}
          disabled={selectedDate === null || selectedHour === null}
        >
          <i className="fa fa-calendar-check-o" aria-hidden="true"></i>
          Confirmar agenda
        </button>
      </div>
    );
  }
}

export default Schedule;
